'use strict';

module.exports = function (ngModule) {
    // L7_APP
        ngModule.controller('appByl7Controller', require('./app_by_l7'));
        ngModule.controller('appByl7RespController', require('./app_by_l7_resp'));
        ngModule.controller('appByl7RespOrigController', require('./app_by_l7_resp_orig'));

    // DNS
        ngModule.controller('dnsByTypeController', require('./dns_by_type'));
        ngModule.controller('dnsByTypeRespController', require('./dns_by_type_resp'));
        ngModule.controller('dnsByTypeRespOrigController', require('./dns_by_type_resp_orig'));
        ngModule.controller('dnsByResolverController', require('./dns_by_resolver'));
        ngModule.controller('dnsByResolverTypeController', require('./dns_by_resolver_type'));

    // HTTP
        ngModule.controller('httpByDomainController', require('./http_by_domain'));
        ngModule.controller('httpByDomainSubController', require('./http_by_domain_sub'));
        ngModule.controller('httpByDomainUriController', require('./http_by_domain_uri'));

    // SSL
        ngModule.controller('sslByServerController', require('./ssl_by_server'));
        ngModule.controller('sslByServerNameController', require('./ssl_by_server_name'));
        ngModule.controller('sslByServerNameOrigController', require('./ssl_by_server_name_orig'));

    // FTP
        ngModule.controller('ftpRespController', require('./ftp_resp'));
        ngModule.controller('ftpRespOrigController', require('./ftp_resp_orig'));

    // SSH
        ngModule.controller('sshStatusController', require('./ssh_status'));
        ngModule.controller('sshStatusRespController', require('./ssh_status_resp'));
        ngModule.controller('sshStatusRespOrigController', require('./ssh_status_resp_orig'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/applications/index.js
 **/